/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon16Light = forwardRef('NetCloudIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.257 5.888a4.125 4.125 0 0 1 7.91-1.388 4.25 4.25 0 0 1 .083 8.5h-7a3.625 3.625 0 0 1-.993-7.112ZM7.375 3a3.125 3.125 0 0 0-3.122 3.267.5.5 0 0 1-.42.516A2.626 2.626 0 0 0 4.25 12h6.955l.029-.002a3.25 3.25 0 1 0-.369-6.488.5.5 0 0 1-.515-.345A3.127 3.127 0 0 0 7.375 3Z" })));
});
